module.exports = __webpack_public_path__ + "static/media/cheque.d2c00f57.png";